import axios, { type AxiosError } from 'axios'
import HttpService from '@/common/services/HttpService'
import { isAccessTokenPropagationToRequestEnabled } from '@/common/helpers/authentication/authenticationUrl'
import { getCurrentKeycloakToken } from '@/common/services/SessionService'
import configResolver from '@/common/helpers/configResolver'
import { displayApiResponseData } from '@/common/services/NotificationDisplayService'
export default function setupAxios() {
  /**
   * Global error interceptor
   *
   * API errors are reported to the user. This behavior can
   * be disabled by switching the config.raw parameter to true.
   */
  HttpService.addResponseInterceptor(
    (response) => response,
    (error: AxiosError | Error) => {
      if (axios.isAxiosError(error)) {
        if (error.config?.raw) return Promise.reject(error)

        const responseDataToken = error.response?.data
        displayApiResponseData(responseDataToken, 'warning')
      }

      return Promise.reject(error)
    },
  )

  HttpService.addRequestInterceptor((config) => {
    if (config.url && isAccessTokenPropagationToRequestEnabled(configResolver.root, config.url)) {
      config.headers['Authorization'] = 'Bearer ' + getCurrentKeycloakToken()
    }
    return config
  })
}
